import { render, staticRenderFns } from "./SocialBlock.vue?vue&type=template&id=340200a9&scoped=true&"
import script from "./SocialBlock.vue?vue&type=script&lang=js&"
export * from "./SocialBlock.vue?vue&type=script&lang=js&"
import style0 from "./SocialBlock.vue?vue&type=style&index=0&id=340200a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "340200a9",
  null
  
)

export default component.exports